import axios from 'axios'
import { put, call, take, fork } from 'redux-saga/effects'

import { FETCH_PROJECT, FETCH_PROJECT_SUCCESS, FETCH_PROJECT_FAILURE } from '../actions/projectActions'
import { SHOW_MODAL_ERROR } from '../actions/noticeActions'

export function* runFetchProjectHandler() {
  while (true) {
    yield take([`${FETCH_PROJECT}`])
    yield fork(fetchProjectHandler)
  }
}

function* fetchProjectHandler() {
  const { data, error } = yield call(fetchProject)
  if (error != null) {
    yield put(FETCH_PROJECT_FAILURE())
    yield put(SHOW_MODAL_ERROR(error.message))
    return
  }
  yield put(FETCH_PROJECT_SUCCESS(data))
}

const fetchProject = () => {
  return axios
    .get('/api/v1/participants/projects')
    .then(function(response) {
      return { data: response.data }
    })
    .catch(function(error) {
      return { error: error.response.data }
    })
}
